/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Font_Color_LabelInputs */



/**
* | output |
* | --- |
* | "Color" |
*
* @param {Image_Export_Font_Color_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_font_color_label = /** @type {((inputs?: Image_Export_Font_Color_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Font_Color_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Couleur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Farbe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Colore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Цвет")
	if (locale === "es") return /** @type {LocalizedString} */ ("Color")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("颜色")
	if (locale === "ja") return /** @type {LocalizedString} */ ("色")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cor")
	return /** @type {LocalizedString} */ ("Color")
});